import { render, staticRenderFns } from "./ChapterIntro.vue?vue&type=template&id=fe1970de&scoped=true&"
import script from "./ChapterIntro.vue?vue&type=script&lang=js&"
export * from "./ChapterIntro.vue?vue&type=script&lang=js&"
import style0 from "./ChapterIntro.vue?vue&type=style&index=0&id=fe1970de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1970de",
  null
  
)

component.options.__file = "ChapterIntro.vue"
export default component.exports